;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();function SandYouLogo({
  className,
  dark = false,
  width = 120,
  height = 60,
}: {
  className?: string;
  dark?: boolean;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      id="Component_6_16"
      data-name="Component 6 – 16"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 118.657 40.614"
      className={className || ''}
    >
      <path
        id="Path_86"
        data-name="Path 86"
        d="M82.879,124.726c0,7.993-5.163,11.883-12.237,11.883-12.874,0-13.015-9.548-13.015-13.439h5.941c0,4.6,1.273,8.771,7.073,8.771,1.91,0,6.3-.919,6.3-6.295,0-5.095-4.669-6.154-9.266-7.712s-9.337-2.9-9.337-10.752c0-7.073,5.517-10.468,12.1-10.468,11.035,0,11.459,7.639,11.53,12.1H76.018c0-4.811-1.273-7.427-5.588-7.427-1.909,0-6.154.495-6.154,5.8,0,4.457,4.669,5.306,9.337,6.862,4.6,1.556,9.266,3.183,9.266,10.68"
        transform="translate(-57.628 -95.994)"
        fill="#d9000d"
      />
      <g id="Group_2" data-name="Group 2" transform="translate(23.071 0.87)">
        <path
          id="Path_87"
          data-name="Path 87"
          d="M144.348,118.022a29.143,29.143,0,0,1-4.057,11.584c1.662,1.32,3.372,2.884,5.572,2.884v3.422c-3.519,0-5.963-1.711-8.114-3.324-2.835,2.444-5.963,4.106-9.825,4.106a10.629,10.629,0,0,1-10.656-10.7c0-5.327,3.324-9.043,7.625-11.682-1.32-2.786-2.639-5.23-2.639-8.9,0-4.693,2.835-8.31,7.332-8.31,4.35,0,7.185,3.226,7.185,7.821,0,4.693-3.275,7.968-6.941,10.411a56.629,56.629,0,0,0,7.918,11.585c1.662-2.249,2.591-6.4,3.177-9.532ZM120.935,125.6c0,4.155,2.933,7.821,7.234,7.821,2.982,0,5.083-1.369,7.088-3.47a69.771,69.771,0,0,1-8.7-12.611C123.428,119.341,120.935,121.59,120.935,125.6Zm12.171-21.311c0-2.3-1.369-4.057-3.568-4.057-2.541,0-3.617,2.688-3.617,5.035a13.679,13.679,0,0,0,2.15,7.087C130.906,110.543,133.106,108.05,133.106,104.286Z"
          transform="translate(-117.269 -97.101)"
          fill={dark ? '#455a63' : '#fff'}
        />
      </g>
      <g id="Group_3" data-name="Group 3" transform="translate(48.218)">
        <path
          id="Path_88"
          data-name="Path 88"
          d="M195.7,127c-1.568,4.963-4.281,8.839-10.029,8.839a9.07,9.07,0,0,1-3.119-.491L183.683,132a4.587,4.587,0,0,0,2.415.422c4.128,0,5.06-3.642,6.105-7.091l-9.928-28.32H186.4l7.837,22.52,7.159-22.52h3.866Z"
          transform="translate(-182.275 -96.177)"
          fill={dark ? '#455a63' : '#fff'}
        />
        <path
          id="Path_89"
          data-name="Path 89"
          d="M244.258,110.109c0-10.816,5.12-15.257,11.547-15.257s11.547,4.441,11.547,15.257-5.121,15.257-11.547,15.257S244.258,120.925,244.258,110.109Zm19.019,0c0-4.912-1.2-11.808-7.471-11.808s-7.472,6.9-7.472,11.808,1.2,11.808,7.472,11.808S263.277,115.021,263.277,110.109Z"
          transform="translate(-220.281 -94.852)"
          fill={dark ? '#455a63' : '#fff'}
        />
        <path
          id="Path_90"
          data-name="Path 90"
          d="M329.565,97.013h4.076v28.842h-4.076v-2.978c-2.4,1.933-4.65,3.814-7.942,3.814-4.076,0-7.368-2.247-7.368-9.771V97.013h4.076v18.863c0,3.03.522,7.472,3.814,7.472,2.508,0,5.8-2.456,7.419-4.389Z"
          transform="translate(-263.201 -96.177)"
          fill={dark ? '#455a63' : '#fff'}
        />
      </g>
    </svg>
  );
}

export default SandYouLogo;
